/**
 * Custom hook to provide current cafeteria statemnt's data
 * in a card with a dougnut chart
 *
 * Component documentation is available in Storybook
 *
 * Pál Pintér <pinter.pal@orgware.hu>
 * Created at: 2021.06.10
 */
import _ from "lodash";
import { useQuery, useSubscription } from "@apollo/react-hooks";
import {
  MY_CAFETERIA_GET_CURRENT_STATEMENT,
  MY_CAFETERIA_SUBSCRIPTION,
} from "my-cafeteria/graphql";
import { useOcPolling } from "oc/hooks";

export const useMyCafeteriaCurrentStatement = ({
  contractCode,
}: {
  contractCode: string;
}) => {
  const { data, loading, error, refetch } = useQuery(
    MY_CAFETERIA_GET_CURRENT_STATEMENT,
    {
      fetchPolicy: "cache-and-network",
      pollInterval: useOcPolling(1000 * 60),
      skip: !contractCode,
      variables: { contractCode },
    },
  );

  const { error: subscriptionError } = useSubscription(
    MY_CAFETERIA_SUBSCRIPTION,
    {
      skip: !contractCode,
      onData: () => {
        refetch();
      },
    },
  );

  /** Parse raw data received from server */
  let dataResult = data?.getCurrentCafeteriaStatement;
  let correctedResult = _.cloneDeep(dataResult);
  if (correctedResult) {
    correctedResult.allCosts = dataResult.allCosts - dataResult.allBenefits;
    correctedResult.availableAmount =
      dataResult.allAmount - dataResult.allBenefits - correctedResult.allCosts;
  }

  return {
    data: correctedResult,
    loading: loading && !data,
    error: error || subscriptionError,
  };
};

export default useMyCafeteriaCurrentStatement;
